/* ==============================
   Hombre — Stats counter
   Animates numeric values from 0 to target when scrolled into view.
   ============================== */
(function () {
  'use strict';

  var DURATION = 1800; // ms
  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function parseValue(raw) {
    if (!raw) return null;
    // Match optional non-digit prefix, integer or decimal number, optional suffix
    var match = String(raw).match(/^(\D*)(\d+(?:[.,]\d+)?)(.*)$/);
    if (!match) return null;
    var prefix = match[1] || '';
    var numStr = match[2].replace(',', '.');
    var suffix = match[3] || '';
    var target = parseFloat(numStr);
    if (isNaN(target)) return null;
    var decimals = (numStr.split('.')[1] || '').length;
    return { prefix: prefix, target: target, suffix: suffix, decimals: decimals };
  }

  function format(value, decimals) {
    return decimals > 0 ? value.toFixed(decimals) : Math.round(value).toString();
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animate(el, parsed) {
    var start = null;
    function step(ts) {
      if (start === null) start = ts;
      var elapsed = ts - start;
      var progress = Math.min(elapsed / DURATION, 1);
      var eased = easeOutCubic(progress);
      var current = parsed.target * eased;
      el.textContent = parsed.prefix + format(current, parsed.decimals) + parsed.suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        el.textContent = parsed.prefix + format(parsed.target, parsed.decimals) + parsed.suffix;
      }
    }
    requestAnimationFrame(step);
  }

  function init() {
    var nodes = document.querySelectorAll('[data-vp-counter]');
    if (!nodes.length) return;

    nodes.forEach(function (el) {
      var parsed = parseValue(el.getAttribute('data-value') || el.textContent);
      if (!parsed) return;
      el.__vpParsed = parsed;
      if (REDUCED) return; // leave final value as is
      // Reset visible text to 0 so the animation has somewhere to count from
      el.textContent = parsed.prefix + format(0, parsed.decimals) + parsed.suffix;
    });

    if (REDUCED || !('IntersectionObserver' in window)) {
      nodes.forEach(function (el) {
        if (el.__vpParsed) animate(el, el.__vpParsed);
      });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          io.unobserve(el);
          if (el.__vpParsed) animate(el, el.__vpParsed);
        });
      },
      { threshold: 0.4 }
    );

    nodes.forEach(function (el) {
      io.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init on Shopify section reload (theme editor)
  document.addEventListener('shopify:section:load', init);
})();
